module.exports = __webpack_public_path__ + "static/media/empty-cart.69166912.svg";